//src/config.js
const getInvitationUrl = (apiBaseUrl) => {
  const url = new URL(apiBaseUrl);
  url.hostname = url.hostname.replace(/^api\./, "");
  return url.toString();
};


const API_BASE_URL =
  // "http://localhost:3001/api",
  //   // "https://backend-dev.thurent.com/api",
  // "https://api.thurent.in/api";
  "https://api.dev.thurent.in/api";



const config = {
  companyName: "Thurent.com",
  eventLocalStorageKey: "createEventFormSession",
  eventEditLocalStorageKey: "editEventFormSession",
  providerListStorageKey: "providerListSession",
  cartItemKey: "cartItemSession",

  API_BASE_URL,
  // "http://localhost:3001/api",
  //   // "https://backend-dev.thurent.com/api",
  // "https://api.thurent.in/api",
  // "https://api.dev.thurent.in/api",
  // API_BASE_URL: 'http://localhost:3001/api',
  // Add other configurations if needed
  INVITATION_URL: `${getInvitationUrl(API_BASE_URL)}/invitation`,
  token:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTcyNTU2NTc2MCwiZXhwIjoxNzI1NTY5MzYwfQ.yHdfylPCyDVYm_8aSEpoC_Yc5YOF-z4__diuPB_C1mQ",


  emailAddress: "nick@thurent.com",
  phoneNumber: "+91 74167-34499",
  companyFullName: "THURENT TECH SERVICES PRIVATE LIMITED",
  contactAddress: "T-Hub\nPhase II Gachibowli,\nHYDERABAD Telangana",

  // Contact Information by Region
  contactInfo: {
    india: {
      name: "Nagesh Kondoori (Nick)",
      title: "Founder and CTO",
      email1: "nick@thurent.com",
      email2: "Tech-admin@thurent.in",
      phone: "+91 74167-34499",
    },
    usa: {
      name: "Armstead Rasheed King III",
      title: "Co-Founder & CEO",
      email1: "Armstead@thurent.us",
      email2: "Tech-admin@thurent.in",
    },
  },
};


export default config;



